import { render, staticRenderFns } from "./TeacherDocumentDataTable.vue?vue&type=template&id=117afb04&scoped=true&"
import script from "./TeacherDocumentDataTable.vue?vue&type=script&lang=js&"
export * from "./TeacherDocumentDataTable.vue?vue&type=script&lang=js&"
import style0 from "./TeacherDocumentDataTable.vue?vue&type=style&index=0&id=117afb04&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "117afb04",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VBtn,VDataTable,VIcon})
